module.exports = __webpack_public_path__ + "img/178-e9885e.png";